import React, { useState, useEffect, useRef } from 'react';
import { getFirestore, collection, addDoc, updateDoc, deleteDoc, doc, getDocs, query, where, writeBatch } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { addCategory, getCategories, deleteCategory } from '../services/firestoreService';
import Swal from 'sweetalert2'; // SweetAlert2 for alerts
import styles from './AdminProducts.module.css'; // Import scoped CSS
import Modal from 'react-modal';
// Nombre de archivo seguro: base “slugificado” + timestamp + extensión
const slugify = (s) =>
  s.toLowerCase()
   .normalize('NFD')
   .replace(/[\u0300-\u036f]/g, '')
   .replace(/[^a-z0-9]+/g, '-')
   .replace(/(^-|-$)/g, '');

const safeName = (file) => {
  const ext = file.name.split('.').pop().toLowerCase();
  const base = file.name.replace(/\.[^.]+$/, '');
  return `${slugify(base)}-${Date.now()}.${ext}`;
};


const AdminProducts = () => {
  const [products, setProducts] = useState([]);
  const [productName, setProductName] = useState('');
  const [productPrice, setProductPrice] = useState('');
  const [productStock, setProductStock] = useState(''); // General stock for all options
  const [productCategories, setProductCategories] = useState([]); // Updated to handle multiple categories
  const [category, setCategory] = useState(''); // Main category, same as before
  const [productShortDescription, setProductShortDescription] = useState(''); // Short Description
  const [productFullDescription, setProductFullDescription] = useState('');
  const [newCategory, setNewCategory] = useState('');
  const [productImages, setProductImages] = useState([]); // Updated to handle multiple images
  const [principalImageIndex, setPrincipalImageIndex] = useState(0); // Track the principal image index
  const [categories, setCategories] = useState([]);
  const [productOptions, setProductOptions] = useState([{ name: '', price: '' }]); // Removed stock from options
  const [showCategories, setShowCategories] = useState(false);
  const [editProduct, setEditProduct] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [addProductModalOpen, setAddProductModalOpen] = useState(false); // Modal state for adding new products
  const [loading, setLoading] = useState(false); // Loading state
  const firestore = getFirestore();
  const storage = getStorage();
  const fileInputRef = useRef(null);
  const [hasTarjeta, setHasTarjeta] = useState(false);
  // --- Filtros ---
// --- Filtros ---
const [filterName, setFilterName] = useState("");
const [filterMinPrice, setFilterMinPrice] = useState("");
const [filterMaxPrice, setFilterMaxPrice] = useState("");

// Dropdown filters
const [filterMainCategory, setFilterMainCategory] = useState("");
const [filterSubcat, setFilterSubcat] = useState("");


// Activo/Desactivado
const [filterStatus, setFilterStatus] = useState(""); // '', 'active', 'disabled'

// --- Category manager UI state ---
const [categorySortOrder, setCategorySortOrder] = useState("asc"); // 'asc' | 'desc'
const [newCategoryManager, setNewCategoryManager] = useState("");

const [editingCategoryId, setEditingCategoryId] = useState(null);
const [editingCategoryName, setEditingCategoryName] = useState("");

// Search in the category manager
const [categorySearch, setCategorySearch] = useState("");


const clearFilters = () => {
  setFilterName("");
  setFilterMinPrice("");
  setFilterMaxPrice("");

  setFilterMainCategory("");
  setFilterSubcat("");

  setFilterStatus("");
};


  // --- Aplicar filtros a la lista de productos ---
// --- Aplicar filtros a la lista de productos ---
const filteredProducts = products.filter((p) => {
  // Nombre
  const byName = filterName
    ? (p.name || "").toLowerCase().includes(filterName.toLowerCase())
    : true;

  // Precio
  const price = Number(p.price || 0);
  const minOK = filterMinPrice !== "" ? price >= Number(filterMinPrice) : true;
  const maxOK = filterMaxPrice !== "" ? price <= Number(filterMaxPrice) : true;
  const byPrice = minOK && maxOK;

  // Categoría principal (p.category es un string)
  const byMainCat = filterMainCategory
    ? (p.category || "") === filterMainCategory
    : true;

  // Subcategoría (p.categories es array de strings)
  const bySubcat = filterSubcat
    ? Array.isArray(p.categories) && p.categories.includes(filterSubcat)
    : true;

  // Estado (activo/desactivado)
  const byStatus =
    filterStatus === "active"
      ? !p.disabled
      : filterStatus === "disabled"
      ? !!p.disabled
      : true;

  return byName && byPrice && byMainCat && bySubcat && byStatus;
});


// --- Pagination (client-side) ---
const [pageSize] = useState(15);
const [currentPage, setCurrentPage] = useState(1);

// Reset to page 1 whenever filters or product count change
// Reset to page 1 only when filters change (not when data changes)
// Reset to page 1 only when filters change (not when data changes)
useEffect(() => {
  setCurrentPage(1);
}, [filterName, filterMinPrice, filterMaxPrice, filterMainCategory, filterSubcat, filterStatus]);

// FIRST compute total pages and slice the page
const totalPages = Math.max(1, Math.ceil(filteredProducts.length / pageSize));
const pagedProducts = React.useMemo(() => {
  const start = (currentPage - 1) * pageSize;
  return filteredProducts.slice(start, start + pageSize);
}, [filteredProducts, currentPage, pageSize]);

// If data changes and current page goes out of range, clamp it
useEffect(() => {
  if (currentPage > totalPages) setCurrentPage(totalPages);
}, [totalPages, currentPage]);


// --- Lazy-load only images/URLs for items that are visible ---
const [visibleIds, setVisibleIds] = useState(new Set());

useEffect(() => {
  firstItemRef.current = null;      // ← reset so the next page can set a new first item
  setVisibleIds(new Set());
}, [currentPage]);

// After page change, scroll to first item (or top pager as fallback)
// After page change, scroll to first item (or top pager) with navbar offset
// After page change (from pager click), scroll with navbar offset
useEffect(() => {
  const id = setTimeout(() => {
    if (!userPagingRef.current) return;   // only when user clicked pager
    userPagingRef.current = false;        // reset flag
    if (firstItemRef.current) {
      scrollToElWithOffset(firstItemRef.current);
    } else if (topPagerRef.current) {
      scrollToElWithOffset(topPagerRef.current);
    }
  }, 0);
  return () => clearTimeout(id);
}, [currentPage]);





const ioRef = useRef(null);

const topPagerRef = useRef(null);
const firstItemRef = useRef(null);

const userPagingRef = useRef(false);

const gotoPage = (next) => {
  if (next === currentPage) return;
  userPagingRef.current = true;
  setCurrentPage(next);
};


// Height of your fixed navbar (tweak if needed)
const NAVBAR_HEIGHT = 150;

// Smooth scroll to element with offset (so the navbar doesn't cover it)
const scrollToElWithOffset = (el, offset = NAVBAR_HEIGHT) => {
  if (!el) return;
  const rect = el.getBoundingClientRect();
  const absoluteY = rect.top + window.pageYOffset;
  window.scrollTo({ top: Math.max(absoluteY - offset, 0), behavior: "smooth" });
};



useEffect(() => {
  ioRef.current = new IntersectionObserver(
    (entries) => {
      setVisibleIds((prev) => {
        const next = new Set(prev);
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const id = entry.target.getAttribute("data-pid");
            if (id) next.add(id);
          }
        });
        return next;
      });
    },
    { root: null, rootMargin: "300px 0px", threshold: 0.01 }
  );
  return () => ioRef.current?.disconnect();
}, []);



function SearchableSelect({
  label,
  options = [],
  value = "",
  onChange,
  placeholder = "Seleccionar Categoría",

  emptyLabel = "Todas",
  // NEW (optional, used only by the modals)
  labelAlign = "left",
  maxWidth, // number (px) or string (e.g. "500px", "40rem")
}) {

  const [open, setOpen] = React.useState(false);
  const [search, setSearch] = React.useState("");
  const wrapRef = React.useRef(null);

  React.useEffect(() => {
    const onClickOutside = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  const filtered = options.filter((opt) =>
    (opt || "").toLowerCase().includes(search.toLowerCase())
  );

  return (
          <div
        ref={wrapRef}
        style={{
          position: "relative",
          width: "100%",
          ...(maxWidth
            ? { maxWidth: typeof maxWidth === "number" ? `${maxWidth}px` : maxWidth, margin: "0 auto" }
            : {}),
        }}
      >

        {label && (
          <label style={{ display: "block", marginBottom: 6, textAlign: labelAlign }}>
            {label}
          </label>
        )}

      {/* Control (looks like a select) */}
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className={styles.inputField || ""}
        style={!styles.inputField ? { width: "100%", padding: "8px", textAlign: "left" } : {}}
      >
        {value || emptyLabel}
      </button>

      {/* Dropdown */}
      {open && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            zIndex: 20,
            background: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: 8,
            boxShadow: "0 10px 24px rgba(0,0,0,0.08)",
          }}
        >
          {/* Search inside dropdown */}
          <div style={{ padding: 8, borderBottom: "1px solid #eee" }}>
            <input
              autoFocus
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Buscar…"
              style={{
                width: "100%",
                padding: 8,
                border: "1px solid #ddd",
                borderRadius: 6,
              }}
            />
          </div>

          {/* Options */}
          <div style={{ maxHeight: 220, overflowY: "auto" }}>
            <div
              onClick={() => {
                onChange("");
                setOpen(false);
                setSearch("");
              }}
              style={{ padding: "10px 12px", cursor: "pointer" }}
            >
              {emptyLabel}
            </div>
            {filtered.map((opt) => (
              <div
                key={opt}
                onClick={() => {
                  onChange(opt);
                  setOpen(false);
                  setSearch("");
                }}
                style={{
                  padding: "10px 12px",
                  cursor: "pointer",
                  background: opt === value ? "#f5f9ff" : "transparent",
                }}
              >
                {opt}
              </div>
            ))}
            {filtered.length === 0 && (
              <div style={{ padding: "10px 12px", color: "#888" }}>Sin resultados</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function SearchableMultiSelect({
  label,
  options = [],
  selected = [],
  onChange,
  placeholder = "Seleccionar Sub Categoría",
  includeAddNew = false,
  addNewLabel = "Agregar Nueva Categoría",
  // NEW (optional, used only by the modals)
  labelAlign = "left",
  maxWidth, // number or string
}) {

  const wrapRef = React.useRef(null);
  const [open, setOpen] = React.useState(false);
  const [search, setSearch] = React.useState("");

  React.useEffect(() => {
    const onClickOutside = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  const allOptions = includeAddNew ? [addNewLabel, ...options] : options;
  const filtered = allOptions.filter((opt) =>
    (opt || "").toLowerCase().includes(search.toLowerCase())
  );

  const toggle = (opt) => {
    if (selected.includes(opt)) onChange(selected.filter((x) => x !== opt));
    else onChange([...selected, opt]);
  };

  const summary = () => {
    if (!selected?.length) return placeholder;
    if (selected.length <= 2) return selected.join(", ");
    return `${selected.slice(0, 2).join(", ")} +${selected.length - 2}`;
  };

  return (
        <div
      ref={wrapRef}
      style={{
        position: "relative",
        width: "100%",
        ...(maxWidth
          ? { maxWidth: typeof maxWidth === "number" ? `${maxWidth}px` : maxWidth, margin: "0 auto" }
          : {}),
      }}
    >

      {label && (
        <label style={{ display: "block", marginBottom: 6, textAlign: labelAlign }}>
          {label}
        </label>
      )}

      {/* same look as your inputs (uses .inputField) */}
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className={styles.inputField || ""}
        style={!styles.inputField ? { width: "100%", padding: "8px", textAlign: "left" } : {}}
      >
        {summary()}
      </button>

      {open && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            zIndex: 30,
            background: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: 8,
            boxShadow: "0 10px 24px rgba(0,0,0,0.08)",
          }}
        >
          {/* search inside dropdown */}
          <div style={{ padding: 8, borderBottom: "1px solid #eee" }}>
            <input
              autoFocus
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Buscar…"
              style={{ width: "100%", padding: 8, border: "1px solid #ddd", borderRadius: 6 }}
            />
          </div>

          {/* options (checkboxes, menu stays open) */}
          <div style={{ maxHeight: 260, overflowY: "auto" }}>
            {filtered.map((opt) => {
              const checked = selected.includes(opt);
              return (
                <label
                  key={opt}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    padding: "10px 12px",
                    cursor: "pointer",
                    background: checked ? "#f5f9ff" : "transparent",
                  }}
                  onMouseDown={(e) => e.preventDefault()}
                >
                  <input type="checkbox" checked={checked} onChange={() => toggle(opt)} />
                  <span>{opt}</span>
                </label>
              );
            })}
            {filtered.length === 0 && (
              <div style={{ padding: "10px 12px", color: "#888" }}>Sin resultados</div>
            )}
          </div>

          {/* footer */}
          <div style={{ display: "flex", justifyContent: "space-between", gap: 8, padding: 8, borderTop: "1px solid #eee" }}>
            <button type="button" onClick={() => onChange([])} style={{ padding: "6px 10px", border: "1px solid #ddd", borderRadius: 6 }}>
              Limpiar
            </button>
            <button type="button" onClick={() => setOpen(false)} style={{ padding: "6px 10px", border: "1px solid #ddd", borderRadius: 6 }}>
              Cerrar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}



// Product list: productId -> principal WebP URL
const [principalWebp, setPrincipalWebp] = useState({});
// Edit modal: original image URL -> WebP URL
const [modalWebpByUrl, setModalWebpByUrl] = useState({});

// Uniform small buttons across tables/cards (esp. on small screens)
const compactButtonStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: 36,       // same height everywhere
  minWidth: 100,    // consistent width
  padding: '0 12px',
  fontSize: 14,
  borderRadius: 8,
};

// Responsive grid + uniform control size for the product filters
const filterGridStyle = {
  display: "grid",
  gap: 12,
  // auto-fit will wrap to 1-per-row on very small screens, 2 or 4 per row as space allows
  gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
};

const filterControlStyle = !styles.inputField
  ? { width: "100%", padding: "10px", height: 40 }
  : {};



// --- image URL helpers ---
const isHttp = (u) => typeof u === "string" && /^https?:\/\//i.test(u);

const toHttpDownloadURL = async (urlOrPath) => {
  if (!urlOrPath) return null;
  try {
    if (isHttp(urlOrPath)) return urlOrPath;
    const storage = getStorage();
    return await getDownloadURL(ref(storage, urlOrPath)); // handles 'products/...'
  } catch (e) {
    return null;
  }
};

const tryWebpVariant = async (urlOrPath) => {
  const storage = getStorage();
  try {
    if (isHttp(urlOrPath)) {
      const encoded = new URL(urlOrPath).pathname.split('/o/')[1]?.split('?')[0];
      if (!encoded) return null;
      const objectPath = decodeURIComponent(encoded);
      const webpPath = objectPath.replace(/\.[^.]+$/, '-w1200.webp');
      return await getDownloadURL(ref(storage, webpPath));
    } else {
      // supports 'gs://bucket/path/file.jpg' or 'products/...'
      const asString = String(urlOrPath);
      let path = asString;
      if (asString.startsWith('gs://')) {
        const firstSlash = asString.indexOf('/', 5);
        path = firstSlash >= 0 ? asString.slice(firstSlash + 1) : '';
      }
      if (!path) return null;
      const webpPath = path.replace(/\.[^.]+$/, '-w1200.webp');
      return await getDownloadURL(ref(storage, webpPath));
    }
  } catch {
    return null;
  }
};


  useEffect(() => {
    const fetchProductsAndCategories = async () => {
      const querySnapshot = await getDocs(collection(firestore, 'products'));
      const productsList = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setProducts(productsList);

      const categoriesSnapshot = await getCategories();
      const categoriesList = categoriesSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setCategories(categoriesList);
    };

    fetchProductsAndCategories();
  }, [firestore]);

// Resolve image URLs only for visible items (better on mobile data)
useEffect(() => {
  let cancelled = false;

  const idsToLoad = Array.from(visibleIds).filter((id) => !principalWebp[id]);
  if (!idsToLoad.length) return;

  (async () => {
    const entries = await Promise.all(
      idsToLoad.map(async (id) => {
        const p = products.find((x) => x.id === id);
        if (!p) return [id, null];

        const orig = p.principalImageUrl || p.imageUrls?.[0];
        if (!orig) return [id, null];

        const webp = await tryWebpVariant(orig);
        if (webp) return [id, webp];

        const http = await toHttpDownloadURL(orig);
        return [id, http];
      })
    );

    if (!cancelled) {
      setPrincipalWebp((prev) => ({
        ...prev,
        ...Object.fromEntries(entries.filter(([, u]) => u)),
      }));
    }
  })();

  return () => {
    cancelled = true;
  };
}, [visibleIds, products]);

  

const handleAddProduct = async () => {
  if (
    !productName ||
    !productPrice ||
    !productStock ||
    productCategories.length === 0 ||
    !category ||
    productImages.length === 0 ||
    !productShortDescription ||
    !productFullDescription
  ) {
    Swal.fire('Error', 'Por favor completa todos los campos obligatorios.', 'error');
    return;
  }

  if (productShortDescription.length > 43) {
    Swal.fire('Error', 'La descripción corta no puede exceder los 43 caracteres.', 'error');
    return;
  }

  setLoading(true);
  try {
    // 1) categorías
    let updatedCategories = [...productCategories];
    if (updatedCategories.includes('Agregar Nueva Categoría') && newCategory) {
      const newCategoryDoc = await addCategory(newCategory);
      updatedCategories.splice(
        updatedCategories.indexOf('Agregar Nueva Categoría'),
        1,
        newCategory
      );
      setCategories([...categories, { id: newCategoryDoc.id, name: newCategory }]);
      setNewCategory('');
    }

    // 2) Crear doc para obtener productId
    const docRef = await addDoc(collection(firestore, 'products'), {
      name: productName,
      price: parseFloat(productPrice),
      stock: parseInt(productStock, 10),
      category,
      categories: updatedCategories,
      shortDescription: productShortDescription,
      fullDescription: productFullDescription,
      imageUrls: [],
      principalImageUrl: '',
      options: productOptions.filter((o) => o.name && o.price),
      hasTarjeta,
      orderCount: 0,
      createdAt: new Date(),
      disabled: false,
    });
    const productId = docRef.id;

    // 3) Subir imágenes a products/{productId}/...
    const imageUrls = [];
    for (const image of productImages) {
      const filename = safeName(image);
      const storageRef = ref(storage, `products/${productId}/${filename}`);
      await uploadBytes(storageRef, image);
      const imageUrl = await getDownloadURL(storageRef);
      imageUrls.push(imageUrl);
    }

    // 4) Principal y actualizar doc
    const principalUrl = imageUrls[principalImageIndex] || imageUrls[0] || '';
    await updateDoc(docRef, {
      imageUrls,
      principalImageUrl: principalUrl,
    });

    Swal.fire('Éxito', '¡Producto agregado exitosamente!', 'success');

    // Limpieza/refresh (lo que ya hacías)
    setProductName('');
    setProductPrice('');
    setProductStock('');
    setCategory('');
    setProductCategories([]);
    setProductShortDescription('');
    setProductFullDescription('');
    setProductImages([]);
    setPrincipalImageIndex(0);
    setProductOptions([{ name: '', price: '' }]);
    fileInputRef.current.value = null;

    const querySnapshot = await getDocs(collection(firestore, 'products'));
    const productsList = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    setProducts(productsList);
    setAddProductModalOpen(false);
  } catch (error) {
    console.error(error);
    Swal.fire('Error', 'Algo salió mal. Por favor intenta nuevamente.', 'error');
  } finally {
    setLoading(false);
  }
};

  

  const handleCategoryChange = (category) => {
    if (productCategories.includes(category)) {
      // If the category is already selected, remove it
      setProductCategories(productCategories.filter((cat) => cat !== category));
    } else {
      // Otherwise, add the category to the list
      setProductCategories([...productCategories, category]);
    }
  };
  
            
  const handleAddOption = () => {
    setProductOptions([...productOptions, { name: '', price: '' }]);
  };

  const handleOptionChange = (index, field, value) => {
    const updatedOptions = productOptions.map((option, i) =>
      i === index ? { ...option, [field]: value } : option
    );
    setProductOptions(updatedOptions);
  };

  const handleDeleteImage = async (imageUrl, e) => {
    e.preventDefault(); // Prevent page reload
    
    setLoading(true);
    try {
      const imageRef = ref(storage, imageUrl);
      await deleteObject(imageRef);
      const updatedImages = editProduct.imageUrls.filter(url => url !== imageUrl);
    
      // If the deleted image is the principal image
      if (imageUrl === editProduct.principalImageUrl) {
        if (updatedImages.length > 0) {
          // Set the first available image as the new principal if there are still images left
          setPrincipalImageIndex(0);
        } else {
          // If no images are left, set principalImageIndex to null
          setPrincipalImageIndex(null);
        }
      }
      
      // Update the editProduct state with the updated images
      setEditProduct({ ...editProduct, imageUrls: updatedImages });
      Swal.fire('Éxito', 'Imagen eliminada exitosamente.', 'success');
    } catch (error) {
      Swal.fire('Error', 'Error al eliminar la imagen.', 'error');
    } finally {
      setLoading(false);
    }
  };
  
  

  const openModal = (product) => {
    setEditProduct(product);
    setProductName(product.name);
    setProductPrice(product.price);
    setProductStock(product.stock);
    setCategory(product.category || ''); // Set the correct category for the product
    setProductCategories(product.categories || []); // Handle multiple categories
    setProductShortDescription(product.shortDescription); // Load short description
    setProductFullDescription(product.fullDescription); // Load Descripción Completa
    setProductImages([]); // Reset product images to empty for updates
    setProductOptions(product.options || [{ name: '', price: '' }]);
    setPrincipalImageIndex(product.imageUrls ? product.imageUrls.indexOf(product.principalImageUrl) : 0);
    setHasTarjeta(product.hasTarjeta || false); // Set hasTarjeta based on the product value
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setEditProduct(null);
    setProductName('');
    setProductPrice('');
    setProductStock('');
    setProductCategories([]); // Reset multiple categories
    setProductShortDescription('');
    setProductFullDescription('');
    setProductImages([]);
    setPrincipalImageIndex(0);
    setProductOptions([{ name: '', price: '' }]);
    fileInputRef.current.value = null;
    setModalIsOpen(false);
  };

  useEffect(() => {
  let cancelled = false;

  (async () => {
    if (!editProduct?.imageUrls?.length) {
      setModalWebpByUrl({});
      return;
    }
    const storage = getStorage();

    const entries = await Promise.all(
      editProduct.imageUrls.map(async (orig) => {
        const webp = await tryWebpVariant(orig);
        if (webp) return [orig, webp];
        const http = await toHttpDownloadURL(orig);
        return [orig, http];
      })
    );


    if (!cancelled) {
      setModalWebpByUrl(Object.fromEntries(entries.filter(([, u]) => u)));
    }
  })();

  return () => { cancelled = true; };
}, [editProduct]);


const handleUpdateProduct = async () => {
  if (
    !productName ||
    !productPrice ||
    !productStock ||
    productCategories.length === 0 ||
    !category ||
    !productShortDescription ||
    !productFullDescription
  ) {
    Swal.fire('Error', 'Por favor completa todos los campos obligatorios, incluidas las descripciones.', 'error');
    return;
  }

  if (productShortDescription.length > 43) {
    Swal.fire('Error', 'La descripción corta no puede exceder los 43 caracteres.', 'error');
    return;
  }

  setLoading(true);
  try {
    if (!editProduct) return;

    // categorías
    let updatedCategories = [...productCategories];
    if (updatedCategories.includes('Agregar Nueva Categoría') && newCategory) {
      const newCategoryDoc = await addCategory(newCategory);
      updatedCategories.splice(updatedCategories.indexOf('Agregar Nueva Categoría'), 1, newCategory);
      setCategories([...categories, { id: newCategoryDoc.id, name: newCategory }]);
      setNewCategory('');
    }

    const productRef = doc(firestore, 'products', editProduct.id);
    let imageUrls = editProduct.imageUrls || [];

    // Subir nuevas imágenes (si se agregaron)
    if (productImages.length > 0) {
      for (const image of productImages) {
        const filename = safeName(image);
        const storageRef = ref(storage, `products/${editProduct.id}/${filename}`);
        await uploadBytes(storageRef, image);
        const imageUrl = await getDownloadURL(storageRef);
        imageUrls.push(imageUrl);
      }
    }

    // Principal
    let principalUrl = editProduct.principalImageUrl || '';
    if (typeof principalImageIndex === 'number' && principalImageIndex >= 0 && principalImageIndex < imageUrls.length) {
      principalUrl = imageUrls[principalImageIndex];
    } else if (!principalUrl && imageUrls.length) {
      principalUrl = imageUrls[0];
    }

    await updateDoc(productRef, {
      name: productName,
      price: parseFloat(productPrice),
      stock: parseInt(productStock, 10),
      category,
      categories: updatedCategories,
      shortDescription: productShortDescription,
      fullDescription: productFullDescription,
      imageUrls,
      principalImageUrl: principalUrl,
      hasTarjeta,
    });

    Swal.fire('Éxito', 'Producto actualizado correctamente.', 'success');
    closeModal();
  } catch (error) {
    console.error(error);
    Swal.fire('Error', 'No se pudo actualizar el producto.', 'error');
  } finally {
    setLoading(false);
  }
};

  


  const handleDeleteProduct = async (id) => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: "¡No podrás deshacer esta acción!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, ¡elimínalo!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        try {
          await deleteDoc(doc(firestore, 'products', id));
          Swal.fire('Eliminado', 'Producto eliminado exitosamente.', 'success');

          // Refresh products list
          const querySnapshot = await getDocs(collection(firestore, 'products'));
          const productsList = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }));
          setProducts(productsList);
        } catch (error) {
          Swal.fire('Error', 'Error al eliminar el producto. Por favor intenta nuevamente.', 'error');
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const handleDisableProduct = async (id, disabled) => {
    setLoading(true);
    try {
      await updateDoc(doc(firestore, 'products', id), { disabled });
      Swal.fire('Éxito', `Producto ${disabled ? 'desactivado' : 'activado'} exitosamente.`, 'success');

      // Refresh products list
      const querySnapshot = await getDocs(collection(firestore, 'products'));
      const productsList = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setProducts(productsList);
    } catch (error) {
      Swal.fire('Error', 'Error al actualizar el producto. Por favor intenta nuevamente.', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleDisableCategory = async (id, disabled) => {
    setLoading(true);
    try {
      const categoryRef = doc(firestore, 'categories', id);
      await updateDoc(categoryRef, { disabled });

      const productsQuery = query(collection(firestore, 'products'), where('category', '==', categories.find(c => c.id === id).name));
      const productsSnapshot = await getDocs(productsQuery);
      const batch = writeBatch(firestore);

      productsSnapshot.forEach((productDoc) => {
        const productRef = doc(firestore, 'products', productDoc.id);
        batch.update(productRef, { disabled });
      });

      await batch.commit();
      Swal.fire('Éxito', `Categoría y sus productos ${disabled ? 'desactivados' : 'activados'} exitosamente.`, 'success');

      // Refresh categories and products lists
      const categoriesSnapshot = await getCategories();
      setCategories(categoriesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));

      const querySnapshot = await getDocs(collection(firestore, 'products'));
      setProducts(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    } catch (error) {
      Swal.fire('Error', 'Error al desactivar/activar la categoría. Por favor intenta nuevamente.', 'error');
    } finally {
      setLoading(false);
    }
  };

    // Create a category from the "Manejo de Categorías" section
const handleAddCategoryManager = async () => {
  const name = (newCategoryManager || "").trim();
  if (!name) {
    Swal.fire("Error", "Ingresa un nombre de categoría.", "error");
    return;
  }
  if (categories.some(c => (c.name || "").toLowerCase() === name.toLowerCase())) {
    Swal.fire("Error", "Ya existe una categoría con ese nombre.", "error");
    return;
  }

  setLoading(true);
  try {
    const newDoc = await addCategory(name);
    setCategories([...categories, { id: newDoc.id, name, disabled: false }]);
    setNewCategoryManager("");
    Swal.fire("Éxito", "Categoría agregada.", "success");
  } catch (e) {
    Swal.fire("Error", "No se pudo agregar la categoría.", "error");
  } finally {
    setLoading(false);
  }
};

const startEditCategory = (cat) => {
  setEditingCategoryId(cat.id);
  setEditingCategoryName(cat.name || "");
};

const cancelEditCategory = () => {
  setEditingCategoryId(null);
  setEditingCategoryName("");
};

// Save category rename and cascade to products.category and products.categories[]
const saveEditCategory = async () => {
  const id = editingCategoryId;
  const newName = (editingCategoryName || "").trim();
  if (!id || !newName) {
    Swal.fire("Error", "Nombre inválido.", "error");
    return;
  }

  const cat = categories.find(c => c.id === id);
  if (!cat) return;

  const oldName = cat.name || "";
  if (oldName === newName) {
    cancelEditCategory();
    return;
  }
  if (categories.some(c => c.id !== id && (c.name || "").toLowerCase() === newName.toLowerCase())) {
    Swal.fire("Error", "Ya existe otra categoría con ese nombre.", "error");
    return;
  }

  setLoading(true);
  try {
    // 1) Update category doc
    await updateDoc(doc(firestore, "categories", id), { name: newName });

    // 2) Cascade rename in products (main category)
    const qMain = query(collection(firestore, "products"), where("category", "==", oldName));
    const snapMain = await getDocs(qMain);

    // 3) Cascade rename in products (subcategories array)
    const qSub = query(collection(firestore, "products"), where("categories", "array-contains", oldName));
    const snapSub = await getDocs(qSub);

    const batch = writeBatch(firestore);

    snapMain.forEach((d) => {
      batch.update(doc(firestore, "products", d.id), { category: newName });
    });

    snapSub.forEach((d) => {
      const data = d.data();
      const arr = Array.isArray(data.categories)
        ? data.categories.map((x) => (x === oldName ? newName : x))
        : [];
      batch.update(doc(firestore, "products", d.id), { categories: arr });
    });

    await batch.commit();

    // Refresh categories list
    const categoriesSnapshot = await getCategories();
    setCategories(categoriesSnapshot.docs.map(docu => ({ id: docu.id, ...docu.data() })));

    Swal.fire("Éxito", "Categoría actualizada.", "success");
    cancelEditCategory();
  } catch (e) {
    Swal.fire("Error", "No se pudo renombrar la categoría.", "error");
  } finally {
    setLoading(false);
  }
};




  const handleDeleteCategory = async (id) => {
    Swal.fire({
      title: '¿Estás seguro?',
  text: "¡No podrás deshacer esta acción!",
  icon: 'warning',
  showCancelButton: true,
  confirmButtonColor: '#d33',
  cancelButtonColor: '#3085d6',
  confirmButtonText: 'Sí, ¡elimínalo!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoading(true);
        try {
          await deleteCategory(id);
          setCategories(categories.filter(category => category.id !== id));
          Swal.fire('Eliminado', 'Categoría eliminada exitosamente.', 'success');
        } catch (error) {
          Swal.fire('Error', 'Error al eliminar la categoría. Por favor intenta nuevamente.', 'error');
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const handleImageUpload = (e) => {
    setProductImages(Array.from(e.target.files)); // Allow multiple image uploads
  };

  const handlePrincipalImageSelect = (index, e) => {
    e.preventDefault(); // Prevent default page reload behavior
    setPrincipalImageIndex(index); // Set the selected image as principal
  };

  const removeNewImage = (idxToRemove) => {
  const existing = editProduct?.imageUrls?.length || 0;
  const abs = existing + idxToRemove;

  setProductImages((prev) => prev.filter((_, i) => i !== idxToRemove));

  if (principalImageIndex === abs) {
    setPrincipalImageIndex(0); // fallback
  } else if (principalImageIndex > abs) {
    setPrincipalImageIndex(principalImageIndex - 1);
  }
};





const sortedCategories = React.useMemo(() => {
  const q = (categorySearch || "").toLowerCase();
  const arr = (categories || []).filter((c) =>
    (c.name || "").toLowerCase().includes(q)
  );
  arr.sort((a, b) =>
    (a.name || "").localeCompare(b.name || "", "es", { sensitivity: "base" })
  );
  if (categorySortOrder === "desc") arr.reverse();
  return arr;
}, [categories, categorySortOrder, categorySearch]);


  return (

    
    <div className={styles.adminProductsContainer}>
      {loading && <div className={styles.loadingOverlay}></div>} {/* Loading Overlay */}
  
      <h2 className={styles.popupTitle}>Admin: Manejo de Productos</h2>
  
      {/* Centered Buttons */}
      <div className={styles.centeredButtonRow}>
        <button className={styles.popupButton} onClick={() => setAddProductModalOpen(true)}>
          Agregar Producto
        </button>
        <button className={styles.popupButton} onClick={() => setShowCategories(!showCategories)}>
          {showCategories ? 'Ocultar Categorías' : 'Mostrar Categorías'}
        </button>
      </div>
  
      {showCategories && (
<div className={styles.categoriesSection}>
  <h3 className={styles.sectionTitle}>Manejo de Categorías</h3>

{/* Toolbar: Nueva categoría + Buscar + Orden (clean layout) */}
<div
  style={{
    display: "grid",
    gap: 16,
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
   alignItems: "start",
    marginBottom: 16,
  }}
>
  {/* Nueva categoría */}
  <div>
    <label style={{ display: "block", marginBottom: 6 }}>Nueva categoría</label>
    <div style={{ display: "flex", gap: 8 }}>
      <input
        type="text"
        value={newCategoryManager}
        onChange={(e) => setNewCategoryManager(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" && newCategoryManager.trim()) {
            handleAddCategoryManager();
          }
        }}
        placeholder="Escribe el nombre…"
        className={styles.inputField || ""}
        style={!styles.inputField ? { padding: 8, width: "100%" } : {}}
      />
      <button
        type="button"
        className={styles.popupButton}
        onClick={handleAddCategoryManager}
        disabled={!newCategoryManager.trim()}
        style={
          !styles.popupButton
            ? { padding: "0 14px", height: 40, whiteSpace: "nowrap" }
            : {}
        }
        title="Agregar categoría"
      >
        Agregar
      </button>
    </div>
  </div>

  {/* Buscar categoría */}
  <div>
    <label style={{ display: "block", marginBottom: 6 }}>Buscar</label>
    <input
      type="text"
      value={categorySearch}
      onChange={(e) => setCategorySearch(e.target.value)}
      placeholder="Buscar por nombre…"
      className={styles.inputField || ""}
      style={!styles.inputField ? { padding: 8, width: "100%" } : {}}
    />
  </div>

  {/* Orden A→Z / Z→A */}
  <div>
    <label style={{ display: "block", marginBottom: 6 }}>Orden</label>
    <select
      value={categorySortOrder}
      onChange={(e) => setCategorySortOrder(e.target.value)}
      className={styles.inputField || ""}
      style={!styles.inputField ? { padding: 8, width: "100%" } : {}}
    >
      <option value="asc">A → Z</option>
      <option value="desc">Z → A</option>
    </select>
  </div>
</div>



  <div className={styles.adminTableContainer}>
    <table className={styles.adminTable}>
      <thead>
        <tr>
          <th>Nombre de Categoría</th>
          <th>Status</th>
          <th style={{ width: 320 }}>Acciones</th>
        </tr>
      </thead>
      <tbody>
        {sortedCategories.map((cat) => (
          <tr key={cat.id}>
            <td>
              {editingCategoryId === cat.id ? (
                <input
                  type="text"
                  value={editingCategoryName}
                  onChange={(e) => setEditingCategoryName(e.target.value)}
                  className={styles.inputField || ""}
                  style={!styles.inputField ? { padding: 6, width: "100%" } : {}}
                />
              ) : (
                cat.name
              )}
            </td>
            <td>{cat.disabled ? "Desactivada" : "Activa"}</td>
            <td>
              {editingCategoryId === cat.id ? (
                <>
                  <button
                  className={`${styles.tableButton} ${styles.activeButton}`}
                  style={compactButtonStyle}
                  onClick={saveEditCategory}
                  type="button"
                >
                  Guardar
                </button>
                <button
                  className={styles.tableButton}
                  style={compactButtonStyle}
                  onClick={cancelEditCategory}
                  type="button"
                >
                  Cancelar
                </button>

                </>
              ) : (
                <>
                <button
                  className={styles.tableButton}
                  style={compactButtonStyle}
                  onClick={() => startEditCategory(cat)}
                  type="button"
                >
                  Editar
                </button>
                <button
                  className={`${styles.tableButton} ${styles.activeButton}`}
                  style={compactButtonStyle}
                  onClick={() => handleDisableCategory(cat.id, !cat.disabled)}
                  type="button"
                >
                  {cat.disabled ? "Activar" : "Desactivar"}
                </button>
                <button
                  className={`${styles.tableButton} ${styles.deleteButton}`}
                  style={compactButtonStyle}
                  onClick={() => handleDeleteCategory(cat.id)}
                  type="button"
                >
                  Eliminar
                </button>

                </>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
</div>

      )}

      
  
  <div className={styles.centeredSection}>
  <h3 className={styles.sectionTitle}>Productos Actuales</h3>

{/* Filtros */}
<div className={styles.filtersCard}>
  {/* Top row: Name + Prices + Status */}
<div className={styles.filtersGrid} style={filterGridStyle}>

    {/* Nombre */}
    <div>
      <label style={{ display: "block", marginBottom: 6 }}>Nombre</label>
      <input
        type="text"
        value={filterName}
        onChange={(e) => setFilterName(e.target.value)}
        placeholder="Buscar por nombre"
        className={styles.inputField || ""}
        style={filterControlStyle}
      />
    </div>

    {/* Precio mín. */}
    <div>
      <label style={{ display: "block", marginBottom: 6 }}>Precio mín.</label>
      <input
        type="number"
        min="0"
        value={filterMinPrice}
        onChange={(e) => setFilterMinPrice(e.target.value)}
        placeholder="0"
        className={styles.inputField || ""}
        style={filterControlStyle}

      />
    </div>

    {/* Precio máx. */}
    <div>
      <label style={{ display: "block", marginBottom: 6 }}>Precio máx.</label>
      <input
        type="number"
        min="0"
        value={filterMaxPrice}
        onChange={(e) => setFilterMaxPrice(e.target.value)}
        placeholder="999999"
        className={styles.inputField || ""}
        style={filterControlStyle}

      />
    </div>

    {/* Estado */}
    <div>
      <label style={{ display: "block", marginBottom: 6 }}>Estado</label>
      <select
        value={filterStatus}
        onChange={(e) => setFilterStatus(e.target.value)}
        className={styles.inputField || ""}
        style={!styles.inputField ? { width: "100%", padding: "8px" } : {}}
      >
        <option value="">Todos</option>
        <option value="active">Activos</option>
        <option value="disabled">Desactivados</option>
      </select>
    </div>
  </div>

  {/* Second row: search-inside dropdowns */}
  <div
    className={styles.filtersGrid}
    style={{
      display: "grid",
      gap: 16,
      gridTemplateColumns: "repeat(2, minmax(0,1fr))",
      marginTop: 12,
    }}
  >
    {/* Categoría principal (search inside dropdown) */}
    <SearchableSelect
      label="Categoría principal"
      value={filterMainCategory}
      onChange={setFilterMainCategory}
      emptyLabel="Todas"
      options={Array.from(
        new Set((categories || []).map((c) => c.name).filter(Boolean))
      )}
    />

    {/* Subcategoría (search inside dropdown) */}
    <SearchableSelect
      label="Subcategoría"
      value={filterSubcat}
      onChange={setFilterSubcat}
      emptyLabel="Todas"
      options={Array.from(
        new Set((categories || []).map((c) => c.name).filter(Boolean))
      )}
    />
  </div>

  {/* Actions */}
  <div style={{ marginTop: 12, display: "flex", gap: 8 }}>
    <button
      className={styles.popupButton || ""}
      style={!styles.popupButton ? { padding: "8px 12px" } : {}}
      onClick={clearFilters}
      type="button"
    >
      Limpiar filtros
    </button>
  </div>
</div>

{/* Pagination bar */}
<div
  ref={topPagerRef}
style={{
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: 8,
  margin: "8px 0 12px",
  flexWrap: "wrap",
  scrollMarginTop: NAVBAR_HEIGHT
}}
>

  <div>
    {filteredProducts.length} productos • Página {currentPage} de {totalPages}
  </div>
  <div style={{ display: "flex", gap: 8 }}>
<button
  className={styles.popupButton}
  onClick={() => gotoPage(Math.max(1, currentPage - 1))}
  disabled={currentPage === 1}
  style={currentPage === 1 ? { opacity: 0.5, cursor: "not-allowed" } : {}}
  type="button"
>
  Anterior
</button>
<button
  className={styles.popupButton}
  onClick={() => gotoPage(Math.min(totalPages, currentPage + 1))}
  disabled={currentPage === totalPages}
  style={currentPage === totalPages ? { opacity: 0.5, cursor: "not-allowed" } : {}}
  type="button"
>
  Siguiente
</button>


  </div>
</div>


<ul className={styles.productList}>
  {pagedProducts.map((product, i) => (
    <li
      key={product.id}
      className={styles.productItem}
      data-pid={product.id}
      style={{ scrollMarginTop: NAVBAR_HEIGHT }}
      ref={(el) => {
        if (!el) return;
        if (ioRef.current) ioRef.current.observe(el);
        if (i === 0) firstItemRef.current = el;
      }}
    >


      <div className={styles.productRow}>
        {/* Lazy image: show skeleton until URL is resolved */}
        {principalWebp[product.id] ? (
          <img
            src={principalWebp[product.id]}
            alt={product.name}
            className={styles.productImage}
            loading="lazy"
            decoding="async"
          />
        ) : (
          <div
            className={styles.productImage}
            style={{ background: "#f1f5f9", borderRadius: 8 }}
            aria-label="Cargando imagen…"
          />
        )}

        <div className={styles.productInfo}>
          <div>{product.name}</div>
          <div>₡{product.price.toLocaleString('en-US')}</div>
          <div>Stock: {product.stock}</div>
          <div>Categoría: {product.category || 'N/A'}</div>
          <div>{product.disabled ? 'Desactivado' : 'Activado'}</div>
        </div>
      </div>
        <div className={styles.buttonGroup}>
        <div
          className={styles.buttonGroup}
          style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}
        >
          <button
            className={styles.popupButton}
            style={compactButtonStyle}
            onClick={() => openModal(product)}
          >
            Editar
          </button>
          <button
            className={`${styles.popupButton} ${styles.activeButton}`}
            style={compactButtonStyle}
            onClick={() => handleDisableProduct(product.id, !product.disabled)}
          >
            {product.disabled ? 'Activar' : 'Desactivar'}
          </button>
          <button
            className={`${styles.popupButton} ${styles.deleteButton}`}
            style={compactButtonStyle}
            onClick={() => handleDeleteProduct(product.id)}
          >
            Eliminar
          </button>
        </div>

        </div>
      </li>
    ))}
  </ul>

  {/* Pagination bar (bottom) */}
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      gap: 8,
      margin: "12px 0 0",
      flexWrap: "wrap",
    }}
  >
    
  <div>
    {filteredProducts.length} productos • Página {currentPage} de {totalPages}
  </div>
  <div style={{ display: "flex", gap: 8 }}>
<button
  className={styles.popupButton}
  onClick={() => gotoPage(Math.max(1, currentPage - 1))}
  disabled={currentPage === 1}
  style={currentPage === 1 ? { opacity: 0.5, cursor: "not-allowed" } : {}}
  type="button"
>
  Anterior
</button>
<button
  className={styles.popupButton}
  onClick={() => gotoPage(Math.min(totalPages, currentPage + 1))}
  disabled={currentPage === totalPages}
  style={currentPage === totalPages ? { opacity: 0.5, cursor: "not-allowed" } : {}}
  type="button"
>
  Siguiente
</button>
    </div>
  </div>

</div>


  
      {/* Modal for editing products */}
<Modal
  isOpen={modalIsOpen}
  onRequestClose={closeModal}
  contentLabel="Edit Product"
  className={styles.ReactModal__Content}
  overlayClassName={styles.ReactModal__Overlay}
>
  <h2 className={styles.modalHeader}>Editar Producto</h2>
  <div className={styles.modalBody}>
    <form className={styles.formCentered}>
      <label>Nombre del Producto</label>
      <input
        type="text"
        value={productName}
        onChange={(e) => setProductName(e.target.value)}
        placeholder="Nombre del Producto"
        className={styles.inputField}
      />

      <label>Precio</label>
      <input
        type="number"
        value={productPrice}
        onChange={(e) => setProductPrice(e.target.value)}
        placeholder="Precio del Producto"
        className={styles.inputField}
      />

      <label>Stock</label>
      <input
        type="number"
        value={productStock}
        onChange={(e) => setProductStock(e.target.value)}
        placeholder="Stock del Producto"
        className={styles.inputField}
      />

      {/* Main Category Selection */}
<SearchableSelect
  label="Categoría Principal"
  value={category}
  onChange={setCategory}
  emptyLabel="Seleccionar Categoría Principal"
  options={Array.from(new Set((categories || []).map((c) => c.name).filter(Boolean)))}
  // modal-only styling:
  labelAlign="center"
  maxWidth={500}
/>



     <h4>Sub Categorías</h4>
<SearchableMultiSelect
  selected={productCategories}
  onChange={setProductCategories}
  includeAddNew={true}
  addNewLabel="Agregar Nueva Categoría"
  options={Array.from(new Set((categories || []).map((c) => c.name).filter(Boolean)))}
  // modal-only styling:
  maxWidth={500}
/>


{productCategories.includes("Agregar Nueva Categoría") && (
  <input
    type="text"
    value={newCategory}
    onChange={(e) => setNewCategory(e.target.value)}
    placeholder="Nueva Categoría"
    className={styles.inputField}
    style={{ marginTop: 8 }}
  />
)}

      <br></br>

      <label>Imágenes</label>
      <input
        type="file"
        multiple
        onChange={handleImageUpload}
        ref={fileInputRef}
        className={styles.inputFile}
      />
      <div className={styles.imagePreview}>
        {editProduct?.imageUrls?.map((imageUrl, index) => (
          <div key={index} className={styles.imageThumbnail}>
            <picture>
              {modalWebpByUrl[imageUrl] && (
                <source type="image/webp" srcSet={`${modalWebpByUrl[imageUrl]} 1x`} />
              )}
              <img
                src={modalWebpByUrl[imageUrl] || imageUrl}
                alt={`Product Image ${index}`}
              />
            </picture>

            <button
              className={index === principalImageIndex ? styles.activeImageButton : styles.inactiveImageButton}
              onClick={(e) => handlePrincipalImageSelect(index, e)}
              type="button"
            >
              {index === principalImageIndex ? 'Principal' : 'Setear'}
            </button>
            <button
              className={styles.deleteButton}
              onClick={(e) => handleDeleteImage(imageUrl, e)} // Pass `e` to prevent default
              type="button"
            >
              Eliminar
            </button>
          </div>
        ))}
      </div>
        
        {productImages.length > 0 && (
  <>
    <h4>Nuevas imágenes (sin guardar)</h4>
    <div className={styles.imagePreview}>
      {productImages.map((file, i) => {
        const existingCount = editProduct?.imageUrls?.length || 0;
        const absIndex = existingCount + i; // combined index for principal logic
        return (
          <div key={i} className={styles.imageThumbnail}>
            <img src={URL.createObjectURL(file)} alt={`Nueva ${i}`} />
            <button
              className={
                absIndex === principalImageIndex
                  ? styles.activeImageButton
                  : styles.inactiveImageButton
              }
              onClick={(e) => handlePrincipalImageSelect(absIndex, e)}
              type="button"
            >
              {absIndex === principalImageIndex ? 'Principal' : 'Setear'}
            </button>
            <button
              className={styles.deleteButton}
              onClick={() => removeNewImage(i)}
              type="button"
            >
              Eliminar
            </button>
          </div>
        );
      })}
    </div>
  </>
)}


      <label>Descripción Resumida</label>
      <input
        type="text"
        value={productShortDescription}
        onChange={(e) => setProductShortDescription(e.target.value)}
        placeholder="Descripción Resumida (Max 43 caract)"
        className={styles.inputField}
      />

      <label>Descripción Completa</label>
      <textarea
        value={productFullDescription}
        onChange={(e) => setProductFullDescription(e.target.value)}
        placeholder="Descripción Completa"
        className={styles.textAreaField}
      />

      <label className={styles.switchLabel}>
        <input
          type="checkbox"
          checked={hasTarjeta}
          onChange={() => setHasTarjeta(!hasTarjeta)}
          className={styles.switchCheckbox}
        />
        <span className={styles.switchSlider}></span>
        Producto con Tarjeta
      </label>

      <h4>Opciones de Producto (Opcional):</h4>
      {productOptions.map((option, index) => (
        <div key={index} className={styles.optionGroup}>
          <label>Nombre</label>
          <input
            type="text"
            value={option.name}
            onChange={(e) => handleOptionChange(index, 'name', e.target.value)}
            placeholder="Nombre de la Opción"
            className={styles.inputField}
          />
          <label>Precio</label>
          <input
            type="number"
            value={option.price}
            onChange={(e) => handleOptionChange(index, 'price', e.target.value)}
            placeholder="Precio"
            className={styles.inputField}
          />
        </div>
      ))}
      <div className={styles.buttonRow}>
        <button type="button" className={styles.popupButton} onClick={handleAddOption}>
          Agregar Opciones
        </button>
        <button type="button" className={styles.popupButton} onClick={handleUpdateProduct} disabled={loading}>
          Actualizar Producto
        </button>
        <button onClick={closeModal} className={styles.modalCloseButton}>
          Cerrar
        </button>
      </div>
    </form>
  </div>
</Modal>

  {/* Modal for adding products */}
<Modal
  isOpen={addProductModalOpen}
  onRequestClose={() => setAddProductModalOpen(false)}
  contentLabel="Add New Product"
  className={styles.ReactModal__Content}
  overlayClassName={styles.ReactModal__Overlay}
>
  <h2 className={styles.modalHeader}>Agregar Nuevo Producto</h2>
  <div className={styles.modalBody}>
    <form className={styles.formCentered}>
      <label>Nombre del Producto</label>
      <input
        type="text"
        value={productName}
        onChange={(e) => setProductName(e.target.value)}
        placeholder="Nombre del Producto"
        className={styles.inputField}
      />

      <label>Precio</label>
      <input
        type="number"
        value={productPrice}
        onChange={(e) => setProductPrice(e.target.value)}
        placeholder="Precio del Producto"
        className={styles.inputField}
      />

      <label>Stock</label>
      <input
        type="number"
        value={productStock}
        onChange={(e) => setProductStock(e.target.value)}
        placeholder="Stock del Producto"
        className={styles.inputField}
      />


      {/* Main Category Selection */}
<SearchableSelect
  label="Categoría Principal"
  value={category}
  onChange={setCategory}
  emptyLabel="Seleccionar Categoría Principal"
  options={Array.from(new Set((categories || []).map((c) => c.name).filter(Boolean)))}
  labelAlign="center"
  maxWidth={500}
/>


      <h4>Sub Categorías</h4>
<SearchableMultiSelect
  selected={productCategories}
  onChange={setProductCategories}
  includeAddNew={true}
  addNewLabel="Agregar Nueva Categoría"
  options={Array.from(new Set((categories || []).map((c) => c.name).filter(Boolean)))}
  maxWidth={500}
/>

{productCategories.includes("Agregar Nueva Categoría") && (
  <input
    type="text"
    value={newCategory}
    onChange={(e) => setNewCategory(e.target.value)}
    placeholder="Nueva Categoría"
    className={styles.inputField}
    style={{ marginTop: 8 }}
  />
)}

      <br></br>

      <label>Imágenes del Producto</label>
      <input
        type="file"
        multiple
        onChange={handleImageUpload}
        ref={fileInputRef}
        className={styles.inputFile}
      />
<div className={styles.imagePreview}>
  {productImages.map((image, index) => (
    <div key={index} className={styles.imageThumbnail}>
      <img src={URL.createObjectURL(image)} alt={`Product Image ${index}`} />
      <button
        type="button"
        className={index === principalImageIndex ? styles.activeImageButton : styles.inactiveImageButton}
        onClick={(e) => handlePrincipalImageSelect(index, e)}
      >
        {index === principalImageIndex ? 'Principal' : 'Setear'}
      </button>
      <button
        type="button"
        className={styles.deleteButton}
        onClick={() => removeNewImage(index)}
      >
        Eliminar
      </button>
    </div>
  ))}
</div>


      <label>Descripción Resumida</label>
      <input
        type="text"
        value={productShortDescription}
        onChange={(e) => setProductShortDescription(e.target.value)}
        placeholder="Descripción Resumida (Max 43 caract)"
        className={styles.inputField}
      />

      <label>Descripción Completa</label>
      <textarea
        value={productFullDescription}
        onChange={(e) => setProductFullDescription(e.target.value)}
        placeholder="Descripción Completa"
        className={styles.textAreaField}
      />

      <label className={styles.switchLabel}>
        <input
          type="checkbox"
          checked={hasTarjeta}
          onChange={() => setHasTarjeta(!hasTarjeta)}
          className={styles.switchCheckbox}
        />
        <span className={styles.switchSlider}></span>
        Producto con Tarjeta
      </label>

      <h4>Opciones de Producto (Opcional):</h4>
      {productOptions.map((option, index) => (
        <div key={index} className={styles.optionGroup}>
          <label>Nombre</label>
          <input
            type="text"
            value={option.name}
            onChange={(e) => handleOptionChange(index, 'name', e.target.value)}
            placeholder="Nombre de la Opción"
            className={styles.inputField}
          />
          <label>Precio</label>
          <input
            type="number"
            value={option.price}
            onChange={(e) => handleOptionChange(index, 'price', e.target.value)}
            placeholder="Precio"
            className={styles.inputField}
          />
        </div>
      ))}
      <div className={styles.buttonRow}>
        <button type="button" className={styles.popupButton} onClick={handleAddOption}>
          Agregar Opciones
        </button>
        <button type="button" className={styles.popupButton} onClick={handleAddProduct} disabled={loading}>
          Agregar Producto
        </button>
        <button onClick={() => setAddProductModalOpen(false)} className={styles.modalCloseButton}>
          Cerrar
        </button>
      </div>
    </form>
  </div>
</Modal>

 

      
    </div>
  );


};

export default AdminProducts;
